import { render } from "./GuidelineOptin.vue?vue&type=template&id=245f4e11&scoped=true"
import script from "./GuidelineOptin.vue?vue&type=script&lang=js"
export * from "./GuidelineOptin.vue?vue&type=script&lang=js"

import "./GuidelineOptin.vue?vue&type=style&index=0&id=245f4e11&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245f4e11"]])

export default __exports__